<template>
  <div class="tabBox">
    <div :class="isMB?'':'leftBox'">
      <div class="title" v-if="!isMB">参数设置</div>
      <el-tabs :tab-position="isMB?'top':'left'"  class="tab" @tab-click="handleClick">
        <el-tab-pane label="往来单位"></el-tab-pane>
        <el-tab-pane label="销售订单"></el-tab-pane>
        <el-tab-pane label="生产工单"></el-tab-pane>
        <el-tab-pane label="员工资料"></el-tab-pane>
        <!-- <el-tab-pane label="生产入库"></el-tab-pane> -->
        <!-- <el-tab-pane label="发货通知单"></el-tab-pane> -->
        <el-tab-pane label="部门资料"></el-tab-pane>
        <el-tab-pane label="入库单"></el-tab-pane>
        <el-tab-pane label="出库单"></el-tab-pane>
        <el-tab-pane label="入库调整单"></el-tab-pane>
        <el-tab-pane label="出库调整单"></el-tab-pane>
        <!-- <el-tab-pane label="采购订单"></el-tab-pane> -->
        <!-- <el-tab-pane label="报价单"></el-tab-pane> -->
        <!-- <el-tab-pane label="入库单"></el-tab-pane> -->
        <!-- <el-tab-pane label="出库单"></el-tab-pane> -->
        <!-- <el-tab-pane label="产品入库单"></el-tab-pane> -->
        <!-- <el-tab-pane label="产品出库单"></el-tab-pane> -->
        <el-tab-pane label="销货单"></el-tab-pane>
        <el-tab-pane label="进货单"></el-tab-pane>
      </el-tabs>
    </div>
    <div class="rightBox" v-loading="loading">
      {{title}}
      <div style="margin-top:5px;padding-left:15px;">
        <el-row class="row-border" style="border:none;">
          <el-col :span="24" :style="isMB?'margin-top:0;':''">
              <span class="title">编码方式</span>
              <el-radio-group v-model="data.CodingMode" :disabled="readonly">
                <el-radio label="自动编码"></el-radio>
                <el-radio label="手动编码"></el-radio>
              </el-radio-group>
          </el-col>
          <el-col :span="24">
              <span class="title">编码前缀</span>
              <el-input   v-model="data.EncodingPrefix" :placeholder="readonly?'':'请填写编码前缀'" style="width:200px;" :disabled="readonly"></el-input>
          </el-col>
          <el-col :span="24">
              <span class="title">编码前缀</span>
              <el-checkbox v-model="data.DateIdYear" :disabled="readonly">年</el-checkbox>
              <el-select v-model="data.DateIdPosition" style="width:100px;" :disabled="readonly">
                <el-option value="2位"></el-option>
                <el-option value="4位"></el-option>
              </el-select>
              <el-checkbox v-model="data.DateIdMonth" class="date" :disabled="readonly">月</el-checkbox>
              <el-checkbox v-model="data.DateIdDay" class="date" style="margin-top:10px;" :disabled="readonly">日</el-checkbox>
          </el-col>
          <el-col :span="24">
              <span class="title">流水号长度</span>
              <el-select v-model="data.SerialNumberLen" style="width:100px;" v-if="!readonly">
                <el-option value="1位"></el-option>
                <el-option value="2位"></el-option>
                <el-option value="3位"></el-option>
                <el-option value="4位"></el-option>
              </el-select>
              <span v-else style="font-size:14px;">{{data.SerialNumberLen}}</span>
          </el-col>
          <el-col :span="24">
              <span class="title">起始值</span>
              <el-input   v-model="data.StartingValue" placeholder="请填写起始值" type="number" style="width:150px;" v-if="!readonly"></el-input>
              <span v-else style="font-size:14px;">{{data.StartingValue}}</span>
          </el-col>
          <el-col :span="24">
              <span class="title">分隔符</span>
              <el-radio-group v-model="data.Separator" :disabled="readonly">
                <el-radio label="无"></el-radio>
                <el-radio label="-"></el-radio>
              </el-radio-group>
          </el-col>
          <el-button type="primary" size="small" class="bn" @click="save" v-if="!readonly">保 存</el-button>
        </el-row>
      </div>
    </div>
  </div>
</template>

<script>
import api from "@/api/sy/parm";

export default {
  data() {
    return {
      data: {
        ParmId: 0,
        ParameterType: "往来单位",
        CodingMode: "自动编码",
        EncodingPrefix: "",
        DateIdYear: false,
        DateIdMonth: false,
        DateIdDay: false,
        DateIdPosition: "",
        SerialNumberLen: "",
        StartingValue: "",
        Separator: "无",
      },
      api,
      title: "客户编码设置",
      loading: false,
      readonly: false,
      isMB: this.$store.state.isMB,
    }
  },
  mounted() {
    this.getData()
    this.readonly = !this.$permission.canWrite()
  },
  methods: {
    getData() {
      this.loading = true
      this.api.list({ ParameterType: this.data.ParameterType }).then(res => {
        this.loading = false
        if(res.Data.length == 0 ) {
          res.Data.push({
            ParmId: 0,
            ParameterType: this.data.ParameterType,
            CodingMode: "",
            EncodingPrefix: "",
            DateIdYear: false,
            DateIdMonth: false,
            DateIdDay: false,
            DateIdPosition: "",
            SerialNumberLen: "",
            StartingValue: "",
            Separator: "",
          })
        } else {
          res.Data[0].DateIdYear = res.Data[0].DateIdYear == "true"
          res.Data[0].DateIdMonth = res.Data[0].DateIdMonth == "true"
          res.Data[0].DateIdDay = res.Data[0].DateIdDay == "true"
          if(res.Data[0].Separator == '') {
            res.Data[0].Separator = '无'
          }
        }
        this.data = res.Data[0]
      })
    },
    save() {
      if(!this.data.SerialNumberLen) {
        this.$message.error("请选择流水号长度")
        return
      }
      if(this.data.StartingValue==="") {
        this.$message.error("请填写初始值")
        return
      }
      if(this.data.Separator == '无') {
        this.data.Separator = ''
      }
      this.loading = true
      this.api.save(this.data).then(res => {
        this.loading = false
        if(res.Code == 0) {
          this.$message.success("保存成功")      
        } else {
          this.$message.error(res.Msg)
        }
        if(this.data.Separator === '') {
          this.data.Separator = '无'
        }    
      })
    },
    handleClick(tab) {
      this.data.ParameterType = tab.label
      this.getData()
      this.title = tab.label + '编码设置'
    }
  }
}
</script>

<style lang="scss" secoped>
.tabBox{
  padding: 0px 0 0 0;
  margin: 10px;
  @media screen and (min-width: 768px) {
    display: flex;
    margin: 25px;
  }
  .leftBox{
    width: fit-content;
    // border-left:1px solid #ddd;
    margin-right: 10px;
    .title{
        height: 50px;
        line-height: 50px;
        width: 100%;
        text-align: center;
        border: 1px solid #ddd;
        // border-left: none;
        cursor: default;
    }
    .tab {
      border-bottom: 1px solid #ddd;
      border-left:1px solid #ddd;
      .is-left{
        margin-right: 0 !important;
      }
      .el-tabs__item {
        padding: 0 30px;
      }
    }
  }
  .rightBox{
    height: fit-content;
    width: 500px;
    border: 1px solid #ddd;
    padding: 10px 0 15px 15px;
    @media screen and (max-width: 767px) {
      width: 100%;
    }
    .el-col{
      margin: 20px 0px 0 0;
    }
    .title{
      font-size: 14px;
      margin: 0px 20px 0 0;
    }
    .date{
      margin: 5px 0 0 76px;
      display: block;
    }
  }
  .bn{
    float:right;
    @media screen and (min-width: 768px) {
      margin:10px 20px 0 0;
    }
  }
}
</style>